<template>
  <div>
    <div class="entete mgb-20px">
      <div class="level" v-if="isEdit">
        <div class="level-left"></div>
        <div class="level-right">
          <a class="button is-addOrEdit" @click="newSecteurUtilisateur()">
            {{ $t('secteurUtilisateur.actions.newSecteurUtilisateur')}}
          </a>
        </div>
      </div>
    </div>
    <v-client-table
                    v-model="secteursUtilisateur"
                    :columns="columns"
                    :options="options"
                    :ref="referenceTable">
      <div slot="secteur" slot-scope="props">
        {{ props.row.libelle }}
      </div>
      <div slot="actif" slot-scope="props">
        <span v-if="props.row.actif">{{ $t('secteurUtilisateur.liste.yes') }}</span>
        <span v-else>{{ $t('secteurUtilisateur.liste.no') }}</span>
      </div>
      <div slot="supprimer" slot-scope="props">
        <a @click="checkPermissions(permsSecteur.supprimer)
          ? removeSecteur(props.row) : showPopUp()">
          <b-icon
            icon="delete-forever"
            type="is-danger"
            :class="{
            'text-access-no-permission' : !checkPermissions(permsSecteur.supprimer)
            }"
          >
          </b-icon>
        </a>
      </div>
    </v-client-table>
    <b-modal
      :active="popUpSecteurSelector"
      class="modal"
      width="600px"
      @close="closePopUpSecteurSelector"
      has-modal-card>
      <popup-secteur-selector @addSecteur="addSecteur" :secteurs="secteurs"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { REFERENCE_TABLE_SECTEUR_UTILISATEUR } from '@/configuration/general/referenceTableConf';
import PopupSecteurSelector from '@/components/commun/secteur/popUpSecteurSelector';
import { SECTEUR } from '@/configuration/general/permissionsParametrageConf';
import messageErreur from '@/services/general/messageErreur';

const Permissions = createNamespacedHelpers('permissions');
const Secteur = createNamespacedHelpers('secteur');

export default {
  components: {
    PopupSecteurSelector,
  },
  props: {
    utilisateur: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      referenceTable: REFERENCE_TABLE_SECTEUR_UTILISATEUR,
      secteursUtilisateur: [],
      popUpSecteurSelector: false,
      permsSecteur: SECTEUR,
    };
  },
  methods: {
    ...Secteur.mapActions({
      loadSecteurs: 'loadSecteurs',
    }),
    newSecteurUtilisateur() {
      this.popUpSecteurSelector = true;
    },
    closePopUpSecteurSelector() {
      this.popUpSecteurSelector = false;
    },
    addSecteur(secteur) {
      const alreadyAdded = this.secteursUtilisateur
        .some(secteurUtilisateur => secteurUtilisateur.id === secteur.id);
      if (secteur && !alreadyAdded) {
        this.secteursUtilisateur.push(secteur);
        this.utilisateur.secteursId = this.secteursUtilisateur.map(su => su.id);
      }
    },
    removeSecteur(row) {
      const index = this.secteursUtilisateur.findIndex(s => s.id === row.id);
      if (index !== -1) {
        this.secteursUtilisateur.splice(index, 1);
        this.utilisateur.secteursId = this.secteursUtilisateur.map(su => su.id);
      }
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Secteur.mapGetters({
      secteurs: 'items',
    }),
    columns() {
      return this.isEdit ? ['secteur', 'type', 'actif', 'supprimer']
        : ['secteur', 'type', 'actif'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          secteur: this.$t('secteurUtilisateur.liste.secteur'),
          type: this.$t('secteurUtilisateur.liste.type'),
          actif: this.$t('secteurUtilisateur.liste.actif'),
          supprimer: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          supprimer: 'colonneSelected',
        },
        sortable: !this.isEdit ? ['secteur', 'type', 'actif'] : [],
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadSecteurs({});
      this.secteursUtilisateur = cloneDeep(this.secteurs)?.filter(secteur => {
        if (this.utilisateur.secteursId) {
          return this.utilisateur.secteursId.some(sId => secteur.id === sId);
        }
        return false;
      });
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
